export default __webpack_public_path__ + "static/media/cartoon-eat.90c60202.gif";